(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ctr-product-market-gate"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.querySelector('[data-ctr-product-gate]');
    if (!root || root.dataset.ctrProductGateReady === 'true') return;
    root.dataset.ctrProductGateReady = 'true';

    // Liquid | t HTML-escapes (&#39;), and | json may emit \u0026. Decode both.
    function parseHtml(value) {
      var str = String(value == null ? '' : value);
      str = str.replace(/\\u([0-9a-fA-F]{4})/g, function(_, hex) {
        return String.fromCharCode(parseInt(hex, 16));
      });
      var el = document.createElement('textarea');
      el.innerHTML = str;
      return el.value;
    }

    function setParsedText(el, value) {
      if (!el) return;
      el.textContent = parseHtml(value);
    }

    // Market is set by Liquid at page render (localization.country).
    // Prefer Shopify.country if present (same value after a market switch + reload).
    function getCountryCode() {
      var fromShopify = window.Shopify && Shopify.country;
      var fromLiquid = root.getAttribute('data-country-code');
      return String(fromShopify || fromLiquid || '').toUpperCase();
    }

    function getCountryName() {
      return parseHtml(root.getAttribute('data-country-name') || getCountryCode());
    }

    var bodyTemplateEl = root.querySelector('[data-ctr-product-gate-body-template]');
    var bodyTemplate = '';
    try {
      bodyTemplate = JSON.parse((bodyTemplateEl && bodyTemplateEl.textContent) || '""');
    } catch (e) {
      bodyTemplate = '';
    }
    bodyTemplate = parseHtml(bodyTemplate) ||
      '%product% isn\'t currently shippable to %country%. We\'ll let you know the moment that changes.';

    var bodyEl = root.querySelector('[data-ctr-product-gate-body]');
    var closeEls = root.querySelectorAll('[data-ctr-product-gate-close]');
    var rulesEl = root.querySelector('[data-ctr-product-gate-rules]');
    var rules = [];

    try {
      rules = JSON.parse((rulesEl && rulesEl.textContent) || '[]');
    } catch (e) {
      rules = [];
    }

    if (!rules.length) return;

    function parseList(value) {
      return String(value || '')
        .split(',')
        .map(function(part) { return part.trim(); })
        .filter(Boolean);
    }

    function normalize(value) {
      return String(value || '').toLowerCase();
    }

    function getActiveRules(countryCode) {
      return rules.filter(function(rule) {
        var countries = parseList(rule.countries).map(function(code) { return code.toUpperCase(); });
        return countries.indexOf(countryCode) !== -1;
      }).map(function(rule) {
        return {
          productName: parseHtml(rule.productName || 'This product'),
          triggers: parseList(rule.triggers).map(normalize).filter(Boolean),
          body: parseHtml(rule.body || '')
        };
      }).filter(function(rule) {
        return rule.triggers.length > 0;
      });
    }

    function buildBody(rule) {
      var countryName = getCountryName();
      var template = rule.body && String(rule.body).trim() ? rule.body : bodyTemplate;
      return template
        .replace(/%product%/g, rule.productName)
        .replace(/\{\{\s*product\s*\}\}/g, rule.productName)
        .replace(/%country%/g, countryName)
        .replace(/\{\{\s*country\s*\}\}/g, countryName);
    }

    function findMatchingRule(anchor, activeRules) {
      var href = normalize(anchor.getAttribute('href') || '');
      var text = normalize(anchor.textContent || '');
      var haystack = href + ' ' + text;

      for (var i = 0; i < activeRules.length; i++) {
        var rule = activeRules[i];
        for (var j = 0; j < rule.triggers.length; j++) {
          var trigger = rule.triggers[j];
          if (trigger && haystack.indexOf(trigger) !== -1) {
            return rule;
          }
        }
      }
      return null;
    }

    function openGate(rule) {
      setParsedText(bodyEl, buildBody(rule));
      root.hidden = false;
    }

    function closeGate() {
      root.hidden = true;
    }

    Array.prototype.forEach.call(closeEls, function(el) {
      el.addEventListener('click', function(event) {
        event.preventDefault();
        closeGate();
      });
    });

    // Market is re-checked on every click against the current country code.
    document.addEventListener('click', function(event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      if (root.contains(target)) return;

      var countryCode = getCountryCode();
      if (!countryCode) return;

      var activeRules = getActiveRules(countryCode);
      if (!activeRules.length) return;

      var anchor = target.closest('a[href]');
      if (!anchor || !(anchor instanceof HTMLAnchorElement)) return;

      var href = anchor.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) {
        return;
      }

      var matchedRule = findMatchingRule(anchor, activeRules);
      if (!matchedRule) return;

      event.preventDefault();
      event.stopPropagation();
      openGate(matchedRule);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
    const customHeader = document.querySelector('.custom-header')
    const customHeaderBurger = document.querySelector('.custom-header__hamburger')
    const customHeaderCartCount = document.querySelector('.custom-header-cart-icon__count')

    if (customHeader && customHeaderBurger) {

      // Toggle menu on hamburger click
      customHeaderBurger.addEventListener('click', function(e) {
        e.stopPropagation()
        customHeader.classList.toggle('custom-header--active')
      })

      // Close when clicking outside
      document.addEventListener('click', function(e) {
        if (!customHeader.contains(e.target)) {
          customHeader.classList.remove('custom-header--active')
        }
      })

      // Close when clicking a nav link or account link
      document.querySelectorAll('.custom-header-nav__anchor, .custom-header__sign-in--mobile').forEach(link => {
        link.addEventListener('click', function() {
          customHeader.classList.remove('custom-header--active')
        })
      })

    }

    if (customHeaderCartCount) {
    setInterval(() => {
        const cartCount = document.querySelector('.cart-bubble__text-count')
        console.log({cartCount})

        customHeaderCartCount.textContent = cartCount
        ? cartCount.textContent.trim()
        : "0"
    }, 300)
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
